<!-- Wrapper-->
<div id="wrapper gray-bg embed" class="embed">

    <!-- Main page wrapper -->
    <div id="embed-wrapper" class="gray-bg">
  
      <!-- Main view/routes wrapper-->
      <router-outlet></router-outlet>
  
    </div>
    <!-- End page wrapper-->
  
  </div>
  <!-- End wrapper-->
  